export const datGheType = "DAT_GHE";
export const huyGheType = "HUY_GHE";